/* Commercial Source product page. Plain JavaScript.
   Buttons pick the Shopify variant. Files and answers are sent as line item properties. */
(function () {
  "use strict";
  var root = document.getElementById("cs-product");
  var dataEl = document.getElementById("cs-product-data");
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);

  function $(sel, r) { return (r || root).querySelector(sel); }
  function $all(sel, r) { return Array.prototype.slice.call((r || root).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function money(c) { var n = c / 100; return "$" + n.toFixed(2).replace(/\.00$/, ""); }
  function money2(c) { return "$" + (c / 100).toFixed(2); }
  function fmtNum(n) { return Number(n).toLocaleString("en-US"); }
  var MAX_MB = 20;

  var ICON = {
    upload: '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M12 16V4m0 0-5 5m5-5 5 5M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="currentColor" opacity=".15"/><path d="m7 12.5 3.2 3L17 9" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    warn: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 3 2 20h20L12 3z" fill="currentColor" opacity=".15" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M12 10v4M12 17h.01" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    err: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="currentColor" opacity=".15"/><path d="m9 9 6 6m0-6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>'
  };
  function art(kind, w) {
    w = w || 260;
    if (kind === "banner") return '<svg viewBox="0 0 200 110" width="' + w + '" aria-hidden="true"><rect x="10" y="20" width="180" height="70" rx="4" fill="#0b0b0c"/><rect x="18" y="28" width="164" height="54" rx="2" fill="#0281ee"/><text x="100" y="62" text-anchor="middle" font-family="Montserrat, Arial" font-weight="900" font-size="18" fill="#fff">GRAND OPENING</text>' + [16, 100, 184].map(function (x) { return '<circle cx="' + x + '" cy="24" r="3" fill="#c9ced6"/><circle cx="' + x + '" cy="86" r="3" fill="#c9ced6"/>'; }).join("") + '</svg>';
    if (kind === "cards") return '<svg viewBox="0 0 200 120" width="' + w + '" aria-hidden="true"><rect x="40" y="18" width="130" height="76" rx="6" fill="#dfe3e8" transform="rotate(-8 105 56)"/><rect x="30" y="30" width="130" height="76" rx="6" fill="#fff" stroke="#e4e7ec"/><rect x="42" y="44" width="28" height="28" rx="14" fill="#0281ee"/><rect x="80" y="48" width="66" height="8" rx="4" fill="#0b0b0c"/><rect x="80" y="62" width="48" height="6" rx="3" fill="#9aa3af"/><rect x="42" y="86" width="104" height="5" rx="2.5" fill="#c9ced6"/></svg>';
    return '<svg viewBox="0 0 200 130" width="' + w + '" aria-hidden="true"><rect x="62" y="8" width="84" height="114" rx="4" fill="#dfe3e8" transform="rotate(6 104 65)"/><rect x="56" y="10" width="84" height="112" rx="4" fill="#fff" stroke="#e4e7ec"/><rect x="64" y="18" width="68" height="44" rx="3" fill="#0281ee"/><rect x="64" y="70" width="60" height="8" rx="4" fill="#0b0b0c"/><rect x="64" y="84" width="68" height="5" rx="2.5" fill="#9aa3af"/><rect x="64" y="94" width="52" height="5" rx="2.5" fill="#9aa3af"/><rect x="64" y="106" width="36" height="8" rx="4" fill="#0b0b0c"/></svg>';
  }

  /* ---------- Product setup (matches the approved mockup) ---------- */
  var SIDES = { label: "Print on", options: [{ id: "1", label: "Front only", files: 1 }, { id: "2", label: "Front and back", files: 2 }] };
  var CONFIG = {
    "banners": {
      kind: "banner", ppi: 75, noun: "banner", sizeLabel: "Pick a size (height x width)", sizeOption: "Size",
      sizes: { "2 x 4 ft": [24, 48], "2 x 6 ft": [24, 72], "3 x 6 ft": [36, 72], "3 x 8 ft": [36, 96], "4 x 6 ft": [48, 72], "4 x 8 ft": [48, 96], "4 x 10 ft": [48, 120], "5 x 10 ft": [60, 120] },
      materialOption: "Material",
      materials: [{ value: "Standard 13oz", label: "Standard", note: "13oz vinyl" }, { value: "Heavy duty 15oz", label: "Heavy duty", note: "15oz vinyl, +30%" }],
      stepper: { min: 1, max: 10 },
      note: "Need a custom size? Email " + D.email
    },
    "business-cards": {
      kind: "cards", ppi: 150, noun: "business card", sizeLabel: "Size", fixedSize: { label: "3.5 x 2 in", h: 2, w: 3.5 },
      qtyOption: "Quantity", qtyLabel: "How many cards?", qtyNotes: { "250": "You get 288", "500": "You get 504", "1000": "You get 1008" }, qtyNoun: "cards",
      finish: { label: "Finish", options: [{ id: "Glossy", label: "Glossy", note: "Shiny" }, { id: "Uncoated", label: "Uncoated", note: "No shine" }] },
      sides: SIDES
    },
    "flyers": {
      kind: "flyer", ppi: 150, noun: "flyer", sizeLabel: "Pick a size", sizeOption: "Size",
      sizes: { "4 x 6 in": [6, 4], "7 x 5 in": [5, 7], "9 x 6 in": [6, 9], "8.5 x 11 in": [11, 8.5] },
      qtyOption: "Quantity", qtyLabel: "How many flyers?", qtyNoun: "flyers",
      note: "Need more than we show? Email " + D.email + " for a quote.",
      sides: SIDES
    }
  };
  var C = CONFIG[D.handle];
  if (!C) {
    // Unknown product: fall back to a simple add to cart.
    $("#cs-add-help").textContent = "This product is not set up for online design upload.";
    return;
  }
  var DELIVERY = "Delivery";
  var FIELDS = {
    banner: [
      ["headline", "Big words (what people see first) *", "Example: GRAND OPENING", true],
      ["details", "Smaller words", "Example: Saturday, Oct 12. Free tacos 11am to 2pm.", false, true],
      ["contact", "Phone, website, or social media", "Example: 915-555-0000  tacoselpaso.com", false],
      ["place", "Where will it hang?", "Example: outside on the fence, seen from the street", false]
    ],
    cards: [
      ["person", "Name on the card *", "Example: Maria Lopez", true],
      ["title", "Job title", "Example: Owner", false],
      ["phone", "Phone", "Example: 915-555-0000", false],
      ["email", "Email", "Example: maria@tacoselpaso.com", false],
      ["web", "Website or social media", "Example: tacoselpaso.com", false],
      ["address", "Address", "Example: 123 Main St, Austin, TX 78701", false],
      ["back", "Back of the card (only if you picked front and back)", "Example: our menu QR code and hours", false, true]
    ],
    flyer: [
      ["headline", "Big words at the top *", "Example: SUMMER SALE", true],
      ["details", "Details", "Example: 20% off all services. July 1 to July 31.", false, true],
      ["when", "Date and time", "Example: Saturday, Oct 12, 10am to 4pm", false],
      ["contact", "Phone, website, or address", "Example: 915-555-0000  123 Main St", false]
    ]
  };
  var FLDS = FIELDS[C.kind];
  var DESIGN_FEE = D.designPrice || 9500;

  /* ---------- Variants ---------- */
  function optIndex(name) { for (var i = 0; i < D.options.length; i++) if (D.options[i] === name) return i; return -1; }
  function valuesOf(name) {
    var i = optIndex(name), seen = [], out = [];
    if (i < 0) return out;
    D.variants.forEach(function (v) { var x = v.options[i]; if (seen.indexOf(x) < 0) { seen.push(x); out.push(x); } });
    return out;
  }
  function findVariant(want) {
    return D.variants.filter(function (v) {
      return Object.keys(want).every(function (k) { var i = optIndex(k); return i < 0 || v.options[i] === want[k]; });
    })[0] || null;
  }
  var sizeValues = C.sizeOption ? valuesOf(C.sizeOption) : [];
  var qtyValues = C.qtyOption ? valuesOf(C.qtyOption) : [];
  var rushValue = valuesOf(DELIVERY).filter(function (v) { return /rush/i.test(v); })[0] || "Rush";
  var stdValue = valuesOf(DELIVERY).filter(function (v) { return !/rush/i.test(v); })[0] || "Standard";

  var params = new URLSearchParams(location.search);
  var sel = {
    size: sizeValues[0] || null,
    material: C.materials ? C.materials[0].value : null,
    qty: C.stepper ? 1 : (qtyValues[0] || null),
    finish: C.finish ? C.finish.options[0].id : null,
    sides: C.sides ? C.sides.options[0].id : null,
    mode: params.get("design") === "1" ? "design" : "upload",
    rush: false
  };
  var files = [null, null];
  var brief = { logo: null, inspo: null, style: "" };
  var confirmed = false;
  var link = "cs" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

  function want(rush) {
    var w = {};
    if (C.sizeOption) w[C.sizeOption] = sel.size;
    if (C.materialOption) w[C.materialOption] = sel.material;
    if (C.qtyOption) w[C.qtyOption] = sel.qty;
    w[DELIVERY] = rush ? rushValue : stdValue;
    return w;
  }
  function qtyExists(q) { var w = want(false); w[C.qtyOption] = q; return !!findVariant(w); }
  function currentSize() {
    if (C.fixedSize) return C.fixedSize;
    var d = C.sizes[sel.size] || [0, 0];
    return { label: sel.size, h: d[0], w: d[1] };
  }
  function neededFiles() {
    if (!C.sides) return 1;
    return C.sides.options.filter(function (o) { return o.id === sel.sides; })[0].files;
  }
  function summary() {
    var useRush = sel.rush && sel.mode !== "design";
    var std = findVariant(want(false));
    var rush = findVariant(want(true));
    var v = useRush ? rush : std;
    var pieces = C.stepper ? sel.qty : 1;
    var total = v ? v.price * pieces : 0;
    if (sel.mode === "design") total += DESIGN_FEE;
    var rushFee = (std && rush) ? (rush.price - std.price) * pieces : 0;
    var qtyLabel = C.stepper ? sel.qty + (sel.qty === 1 ? " banner" : " banners") : sel.qty + " " + C.qtyNoun + (C.qtyNotes && C.qtyNotes[sel.qty] ? " (" + C.qtyNotes[sel.qty].toLowerCase() + ")" : "");
    return { variant: v, total: total, rushFee: rushFee, qtyLabel: qtyLabel, size: currentSize(), pieces: pieces };
  }
  function materialLabel() { if (!C.materials) return ""; return C.materials.filter(function (m) { return m.value === sel.material; })[0].label; }
  function finishLabel() { if (!C.finish) return ""; return C.finish.options.filter(function (o) { return o.id === sel.finish; })[0].label; }
  function sidesLabel() { if (!C.sides) return ""; return C.sides.options.filter(function (o) { return o.id === sel.sides; })[0].label; }

  /* ---------- Option buttons ---------- */
  function buildOptions() {
    var h = "";
    if (C.fixedSize) {
      h += '<div class="cs-field"><span class="cs-field-label">' + esc(C.sizeLabel) + '</span><div class="cs-choice-grid"><button type="button" class="cs-choice" aria-pressed="true" disabled style="opacity:1">' + esc(C.fixedSize.label) + '</button></div></div>';
    } else {
      h += '<div class="cs-field"><span class="cs-field-label">' + esc(C.sizeLabel) + '</span><div class="cs-choice-grid" role="group" aria-label="Size">' +
        sizeValues.map(function (s) {
          var sub = "";
          if (C.stepper) { var w = want(false); w[C.sizeOption] = s; w[C.materialOption] = C.materials[0].value; var v = findVariant(w); if (v) sub = '<small>' + money(v.price) + ' each</small>'; }
          return '<button type="button" class="cs-choice" data-size="' + esc(s) + '" aria-pressed="false">' + esc(s) + sub + '</button>';
        }).join("") + '</div></div>';
    }
    if (C.materials) {
      h += '<div class="cs-field"><span class="cs-field-label">Material</span><div class="cs-choice-grid" role="group" style="grid-template-columns:1fr 1fr">' +
        C.materials.map(function (m) { return '<button type="button" class="cs-choice" data-material="' + esc(m.value) + '" aria-pressed="false">' + esc(m.label) + '<small>' + esc(m.note) + '</small></button>'; }).join("") + '</div></div>';
    }
    if (C.finish) {
      h += '<div class="cs-field"><span class="cs-field-label">' + esc(C.finish.label) + '</span><div class="cs-choice-grid" role="group" style="grid-template-columns:1fr 1fr">' +
        C.finish.options.map(function (o) { return '<button type="button" class="cs-choice" data-finish="' + esc(o.id) + '" aria-pressed="false">' + esc(o.label) + '<small>' + esc(o.note) + '</small></button>'; }).join("") + '</div></div>';
    }
    if (C.sides) {
      h += '<div class="cs-field"><span class="cs-field-label">' + esc(C.sides.label) + '</span><div class="cs-choice-grid" role="group" style="grid-template-columns:1fr 1fr">' +
        C.sides.options.map(function (o) { return '<button type="button" class="cs-choice" data-sides="' + o.id + '" aria-pressed="false">' + esc(o.label) + '<small>Same price</small></button>'; }).join("") + '</div></div>';
    }
    if (C.stepper) {
      h += '<div class="cs-field"><span class="cs-field-label" id="cs-qty-label">How many?</span><div class="cs-stepper" role="group" aria-labelledby="cs-qty-label"><button type="button" data-step="-1" aria-label="One less">−</button><output id="cs-qty-out" aria-live="polite">1</output><button type="button" data-step="1" aria-label="One more">+</button></div></div>';
    } else if (C.qtyOption) {
      h += '<div class="cs-field"><span class="cs-field-label">' + esc(C.qtyLabel) + '</span><div class="cs-choice-grid" role="group">' +
        qtyValues.map(function (q) { return '<button type="button" class="cs-choice" data-qty="' + esc(q) + '" aria-pressed="false">' + esc(q) + (C.qtyNotes && C.qtyNotes[q] ? '<small>' + esc(C.qtyNotes[q]) + '</small>' : '') + '</button>'; }).join("") + '</div></div>';
    }
    if (C.note) {
      h += '<div class="cs-note">' + esc(C.note).replace(esc(D.email), '<a href="mailto:' + esc(D.email) + '">' + esc(D.email) + '</a>') + '</div>';
    }
    $("#cs-options").innerHTML = h;

    $all("[data-size]").forEach(function (b) { b.addEventListener("click", function () {
      sel.size = b.getAttribute("data-size");
      if (C.qtyOption && !qtyExists(sel.qty)) sel.qty = qtyValues.filter(qtyExists)[0];
      setConfirmed(false); renderUploads(); refresh();
    }); });
    $all("[data-material]").forEach(function (b) { b.addEventListener("click", function () { sel.material = b.getAttribute("data-material"); refresh(); }); });
    $all("[data-finish]").forEach(function (b) { b.addEventListener("click", function () { sel.finish = b.getAttribute("data-finish"); refresh(); }); });
    $all("[data-sides]").forEach(function (b) { b.addEventListener("click", function () {
      sel.sides = b.getAttribute("data-sides");
      if (neededFiles() === 1) clearFile(1);
      setConfirmed(false); renderUploads(); refresh();
    }); });
    $all("[data-qty]").forEach(function (b) { b.addEventListener("click", function () { if (b.disabled) return; sel.qty = b.getAttribute("data-qty"); refresh(); }); });
    $all("[data-step]").forEach(function (b) { b.addEventListener("click", function () {
      var n = sel.qty + Number(b.getAttribute("data-step"));
      sel.qty = Math.max(C.stepper.min, Math.min(C.stepper.max, n)); refresh();
    }); });
  }

  /* ---------- Files ---------- */
  var ACCEPT_RE = /\.(jpe?g|png|pdf)$/i;
  function readFile(f, done) {
    var name = f.name || "design";
    if (f.size > MAX_MB * 1024 * 1024) { done({ error: "This file is too big. Please use a file under " + MAX_MB + " MB, or email it to " + D.email + " after you order." }); return; }
    var isPdf = f.type === "application/pdf" || /\.pdf$/i.test(name);
    var isImg = f.type === "image/jpeg" || f.type === "image/png" || /\.(jpe?g|png)$/i.test(name);
    if (!isPdf && !isImg) { done({ error: "Please use a JPG, PNG, or PDF file." }); return; }
    if (isPdf) { done({ kind: "pdf", name: name, thumb: "", w: 0, h: 0 }); return; }
    var url = URL.createObjectURL(f);
    var img = new Image();
    img.onload = function () {
      var w = img.naturalWidth, h = img.naturalHeight;
      var max = 240, scale = Math.min(1, max / Math.max(w, h));
      var c = document.createElement("canvas");
      c.width = Math.max(1, Math.round(w * scale)); c.height = Math.max(1, Math.round(h * scale));
      var ctx = c.getContext("2d"); ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, c.width, c.height); ctx.drawImage(img, 0, 0, c.width, c.height);
      var thumb = ""; try { thumb = c.toDataURL("image/jpeg", 0.8); } catch (e) { thumb = ""; }
      done({ kind: "image", name: name, w: w, h: h, thumb: thumb, full: url });
    };
    img.onerror = function () { done({ error: "We could not open that picture. Please try another JPG or PNG." }); };
    img.src = url;
  }
  function checkPicture(f, size) {
    if (f.kind === "pdf") return { level: "ok", lines: ["PDF received."] };
    var needLong = Math.round(Math.max(size.w, size.h) * C.ppi), needShort = Math.round(Math.min(size.w, size.h) * C.ppi);
    var haveLong = Math.max(f.w, f.h), haveShort = Math.min(f.w, f.h);
    if (haveLong >= needLong && haveShort >= needShort) return { level: "ok", lines: ["Looks good for this size."] };
    var needW = size.w >= size.h ? needLong : needShort, needH = size.w >= size.h ? needShort : needLong;
    var noun = (size.h >= 24 || size.w >= 24) ? "banner" : "print";
    return { level: "warn", lines: [
      "This picture is too small for a " + size.label + " " + noun + ". It may print blurry.",
      "For best results, use a picture at least " + fmtNum(needW) + " x " + fmtNum(needH) + " pixels. Yours is " + fmtNum(f.w) + " x " + fmtNum(f.h) + ". You can still order. Check the box below to go on."
    ] };
  }
  function fileInput(i) { return document.getElementById("cs-file-" + i); }
  function clearFile(i) { files[i] = null; var inp = fileInput(i); if (inp) inp.value = ""; }
  function setInputFile(inp, file) {
    try { var dt = new DataTransfer(); dt.items.add(file); inp.files = dt.files; return true; } catch (e) { return false; }
  }

  function renderUploads() {
    var wrap = $("#cs-uploads");
    if (sel.mode === "design") { wrap.innerHTML = ""; return; }
    var n = neededFiles(), html = "";
    for (var i = 0; i < n; i++) {
      html += (n > 1 ? '<p class="cs-upload-title">' + (i === 0 ? "Front side" : "Back side") + '</p>' : '<span class="cs-field-label" style="margin-top:20px">Upload your design</span>') + '<div data-slot="' + i + '"></div>';
    }
    wrap.innerHTML = html;
    for (var j = 0; j < n; j++) renderSlot(j);
  }
  function renderSlot(i) {
    var slot = $('[data-slot="' + i + '"]');
    if (!slot) return;
    var f = files[i];
    if (!f) {
      var label = neededFiles() > 1 ? (i === 0 ? "Upload Front Design" : "Upload Back Design") : "Upload Your Design";
      slot.innerHTML = '<label class="cs-upload-box" tabindex="0" for="cs-file-' + i + '"><div class="cs-up-icon">' + ICON.upload + '</div><strong>' + label + '</strong><span>Drag it here, or tap to choose a file.<br>JPG, PNG, or PDF.</span></label><div class="cs-slot-msg"></div>';
      var box = slot.querySelector(".cs-upload-box");
      box.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fileInput(i).click(); } });
      ["dragenter", "dragover"].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.add("cs-drag"); }); });
      ["dragleave", "drop"].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.remove("cs-drag"); }); });
      box.addEventListener("drop", function (e) {
        var dt = e.dataTransfer;
        if (dt && dt.files && dt.files[0]) { if (setInputFile(fileInput(i), dt.files[0])) takeFile(i, dt.files[0]); }
      });
      return;
    }
    var chk = checkPicture(f, currentSize());
    var thumbStyle = f.thumb ? ' style="background-image:url(' + f.thumb + ')"' : "";
    slot.innerHTML = '<div class="cs-preview"><div class="cs-thumb"' + thumbStyle + '>' + (f.kind === "pdf" ? "PDF" : "") + '</div><div><div class="cs-fname">' + esc(f.name) + '</div>' +
      '<div class="cs-muted" style="font-size:.9em">' + (f.kind === "pdf" ? "PDF file" : fmtNum(f.w) + " x " + fmtNum(f.h) + " pixels") + '</div>' +
      '<div class="cs-actions"><button type="button" class="cs-change">Change file</button></div></div></div>' +
      (f.kind === "image" ? '<div class="cs-big-preview"><img src="' + (f.full || f.thumb) + '" alt="Preview of your design"></div>' : '') +
      '<div class="cs-status cs-' + chk.level + '">' + (chk.level === "ok" ? ICON.check : ICON.warn) + '<div>' + chk.lines.map(function (l) { return '<p>' + esc(l) + '</p>'; }).join("") + '</div></div>';
    slot.querySelector(".cs-change").addEventListener("click", function () { clearFile(i); setConfirmed(false); renderSlot(i); refresh(); fileInput(i).click(); });
  }
  function takeFile(i, f) {
    readFile(f, function (res) {
      var slot = $('[data-slot="' + i + '"]');
      if (res.error) {
        clearFile(i);
        var msg = slot && slot.querySelector(".cs-slot-msg");
        if (msg) msg.innerHTML = '<div class="cs-status cs-err">' + ICON.err + '<div><p>' + esc(res.error) + '</p></div></div>';
        return;
      }
      files[i] = res; setConfirmed(false); renderSlot(i); refresh();
    });
  }
  [0, 1].forEach(function (i) { fileInput(i).addEventListener("change", function () { var f = fileInput(i).files[0]; if (f) takeFile(i, f); }); });

  /* ---------- Photo ---------- */
  function mockOne(f, size) {
    var ratio = size.w / size.h;
    if (f.kind === "pdf") return '<div class="cs-mock cs-mock-' + C.kind + ' cs-mock-pdf" style="aspect-ratio:' + ratio + '"><span>PDF uploaded<br><small>We email you a proof before printing</small></span></div>';
    var grom = C.kind === "banner" ? '<i class="cs-g cs-g1"></i><i class="cs-g cs-g2"></i><i class="cs-g cs-g3"></i><i class="cs-g cs-g4"></i>' : "";
    return '<div class="cs-mock cs-mock-' + C.kind + '" style="aspect-ratio:' + ratio + ';background-image:url(' + (f.full || f.thumb) + ')">' + grom + '</div>';
  }
  function updatePhoto() {
    var box = $("#cs-photo");
    if (sel.mode === "design") { box.className = "cs-product-photo"; box.innerHTML = art(C.kind) + '<span><strong>We design it for you.</strong> You approve the proof by email.</span>'; return; }
    var n = neededFiles(), any = false;
    for (var i = 0; i < n; i++) if (files[i]) any = true;
    if (!any) { box.className = "cs-product-photo"; box.innerHTML = art(C.kind) + '<span>Upload your design to see it here</span>'; return; }
    var size = currentSize(), parts = [];
    for (var k = 0; k < n; k++) if (files[k]) parts.push('<figure>' + mockOne(files[k], size) + (n > 1 ? '<figcaption>' + (k === 0 ? "Front" : "Back") + '</figcaption>' : '') + '</figure>');
    box.className = "cs-product-photo cs-has-mock" + (C.finish && sel.finish === "Glossy" ? " cs-is-gloss" : "");
    box.innerHTML = '<div class="cs-mock-wall cs-mock-wall-' + C.kind + '">' + parts.join("") + '</div><span>Preview of your ' + esc(size.label) + ' ' + esc(C.noun) + '</span>';
  }

  /* ---------- Design it for me ---------- */
  function renderDesignForm() {
    var box = $("#cs-design-form");
    if (sel.mode !== "design") { box.innerHTML = ""; return; }
    var styles = ["Bold", "Clean", "Fun", "Elegant"];
    box.innerHTML = '<div class="cs-design-box">' +
      '<p class="cs-design-intro"><strong>Tell us what you want. We do the rest.</strong><br>We email you a proof within ' + esc(D.designDays) + '. We print after you approve it.</p>' +
      '<div class="cs-form-group"><label for="cs-d-biz">Business name *</label><input id="cs-d-biz" autocomplete="organization"></div>' +
      FLDS.map(function (f) {
        var input = f[4] ? '<textarea id="cs-d-' + f[0] + '" rows="3" placeholder="' + esc(f[2]) + '"></textarea>' : '<input id="cs-d-' + f[0] + '" placeholder="' + esc(f[2]) + '">';
        return '<div class="cs-form-group"><label for="cs-d-' + f[0] + '">' + esc(f[1]) + '</label>' + input + '</div>';
      }).join("") +
      '<span class="cs-field-label">Your logo</span><p class="cs-muted" style="margin:-6px 0 8px;font-size:.9em">PDF is best. We also take AI, EPS, or SVG files. We can\'t use a PNG or JPG picture of your logo.</p><div id="cs-d-logo"></div>' +
      '<label class="cs-confirm" style="margin-top:8px"><input type="checkbox" id="cs-d-nologo"><span>I don\'t have a logo. Just use my business name.</span></label>' +
      '<div class="cs-form-group" style="margin-top:16px"><label for="cs-d-colors">Colors</label><input id="cs-d-colors" placeholder="Example: red and black, or match my logo"></div>' +
      '<span class="cs-field-label">Style</span><div class="cs-choice-grid" role="group">' + styles.map(function (s) { return '<button type="button" class="cs-choice" data-style="' + s + '" aria-pressed="' + (brief.style === s) + '">' + s + '</button>'; }).join("") + '</div>' +
      '<span class="cs-field-label" style="margin-top:16px">Something you like (optional)</span><p class="cs-muted" style="margin:-6px 0 8px;font-size:.9em">A photo of a sign or design you like, or a picture to use.</p><div id="cs-d-inspo"></div>' +
      '<div class="cs-form-group" style="margin-top:16px"><label for="cs-d-notes">Anything else? (optional)</label><textarea id="cs-d-notes" rows="3" placeholder="Example: make the phone number big"></textarea></div>' +
      '<label class="cs-confirm"><input type="checkbox" id="cs-d-spell"><span>I checked my spelling, phone numbers, and emails. *</span></label>' +
      '<div class="cs-rev-box"><strong>How changes work</strong>' +
        '<p>1. We send you a proof by email within ' + esc(D.designDays) + '.</p>' +
        '<p>2. You get ' + D.freeRevisions + ' free changes.</p>' +
        '<p>3. Each change after that is $' + D.revisionFee + '.</p>' +
        '<p class="cs-muted">Tip: the more you tell us now, the fewer changes you need.</p></div>' +
      '</div>';
    miniUpload("cs-d-logo", "logo", "Upload Your Logo");
    miniUpload("cs-d-inspo", "inspo", "Upload a Picture");
    ["biz"].concat(FLDS.filter(function (f) { return f[3]; }).map(function (f) { return f[0]; })).forEach(function (id) {
      $("#cs-d-" + id).addEventListener("input", function () { setConfirmed(false); refresh(); });
    });
    $("#cs-d-spell").addEventListener("change", refresh);
    $("#cs-d-nologo").addEventListener("change", refresh);
    $all("[data-style]").forEach(function (b) { b.addEventListener("click", function () {
      brief.style = b.getAttribute("data-style");
      $all("[data-style]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
    }); });
  }
  function miniInput(key) { return document.getElementById(key === "logo" ? "cs-file-logo" : "cs-file-inspo"); }
  function miniUpload(slotId, key, label) {
    var slot = document.getElementById(slotId);
    if (!slot) return;
    var f = brief[key];
    var inp = miniInput(key);
    if (f) {
      var th = f.thumb ? ' style="background-image:url(' + f.thumb + ')"' : "";
      slot.innerHTML = '<div class="cs-preview"><div class="cs-thumb"' + th + '>' + (f.kind === "image" ? "" : esc(f.kind.toUpperCase())) + '</div><div><div class="cs-fname">' + esc(f.name) + '</div><div class="cs-actions"><button type="button" class="cs-change">Remove</button></div></div></div>';
      slot.querySelector(".cs-change").addEventListener("click", function () { brief[key] = null; inp.value = ""; miniUpload(slotId, key, label); refresh(); });
      return;
    }
    var isLogo = key === "logo";
    slot.innerHTML = '<label class="cs-upload-box cs-upload-small" tabindex="0" for="' + inp.id + '"><strong>' + label + '</strong><span>' + (isLogo ? "PDF (best), AI, EPS, or SVG" : "JPG, PNG, or PDF") + '</span></label><div class="cs-slot-msg"></div>';
    slot.querySelector("label").addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); inp.click(); } });
  }
  function takeMini(key) {
    var inp = miniInput(key), f = inp.files[0];
    if (!f) return;
    var slotId = key === "logo" ? "cs-d-logo" : "cs-d-inspo", label = key === "logo" ? "Upload Your Logo" : "Upload a Picture";
    function fail(msg) { inp.value = ""; var s = document.getElementById(slotId); var m = s && s.querySelector(".cs-slot-msg"); if (m) m.innerHTML = '<div class="cs-status cs-err">' + ICON.err + '<div><p>' + esc(msg) + '</p></div></div>'; }
    if (f.size > MAX_MB * 1024 * 1024) { fail("This file is too big. Please use a file under " + MAX_MB + " MB."); return; }
    if (key === "logo") {
      var m = (f.name || "").toLowerCase().match(/\.(pdf|ai|eps|svg)$/);
      if (!m) { fail("Please upload your logo as a PDF (best) or an AI, EPS, or SVG file. A PNG or JPG picture won't work for a logo."); return; }
      brief.logo = { kind: m[1], name: f.name, thumb: "" }; miniUpload(slotId, key, label); refresh(); return;
    }
    readFile(f, function (res) { if (res.error) { fail(res.error); return; } brief.inspo = res; miniUpload(slotId, key, label); refresh(); });
  }
  miniInput("logo").addEventListener("change", function () { takeMini("logo"); });
  miniInput("inspo").addEventListener("change", function () { takeMini("inspo"); });

  function designReady() {
    var biz = $("#cs-d-biz");
    if (!biz || !biz.value.trim()) return false;
    for (var i = 0; i < FLDS.length; i++) if (FLDS[i][3]) { var el = $("#cs-d-" + FLDS[i][0]); if (!el || !el.value.trim()) return false; }
    var sp = $("#cs-d-spell");
    return !!(sp && sp.checked);
  }

  /* ---------- Delivery ---------- */
  function renderDelivery() {
    var box = $("#cs-delivery");
    if (sel.mode === "design") {
      sel.rush = false;
      box.innerHTML = '<span class="cs-field-label">Delivery</span><div class="cs-note" style="margin-top:0">We email your proof within ' + esc(D.designDays) + '. After you approve it, your order arrives in about ' + esc(D.deliveryDays) + '.</div>';
      return;
    }
    box.innerHTML = '<span class="cs-field-label">Delivery</span><div class="cs-choice-grid" role="group" style="grid-template-columns:1fr 1fr">' +
      '<button type="button" class="cs-choice" data-rush="no" aria-pressed="false">Standard<small>' + esc(D.deliveryDays) + '. Included</small></button>' +
      '<button type="button" class="cs-choice" data-rush="yes" aria-pressed="false">Rush: next day<small id="cs-rush-price"></small></button>' +
      '</div><p class="cs-muted" id="cs-rush-note" style="font-size:.9em;margin:8px 0 0"></p>';
    $all("[data-rush]").forEach(function (b) { b.addEventListener("click", function () { sel.rush = b.getAttribute("data-rush") === "yes"; refresh(); }); });
  }

  /* ---------- Confirm and refresh ---------- */
  function setConfirmed(v) { confirmed = v; var box = $("#cs-confirm"); if (box) box.checked = v; }
  function allFilesIn() { var n = neededFiles(); for (var i = 0; i < n; i++) if (!files[i]) return false; return true; }

  function refresh() {
    if (C.qtyOption && !qtyExists(sel.qty)) sel.qty = qtyValues.filter(qtyExists)[0];
    updatePhoto();
    var s = summary();
    $("#cs-price").textContent = money(s.total);
    $("#cs-price-sub").textContent = [s.size.label, materialLabel(), finishLabel(), sidesLabel(), s.qtyLabel, (sel.rush && sel.mode !== "design") ? "Rush" : ""].filter(Boolean).join(" · ");
    $all("[data-size]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-size") === sel.size)); });
    $all("[data-material]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-material") === sel.material)); });
    $all("[data-finish]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-finish") === sel.finish)); });
    $all("[data-sides]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-sides") === sel.sides)); });
    $all("[data-qty]").forEach(function (b) { var q = b.getAttribute("data-qty"); var ok = qtyExists(q); b.disabled = !ok; b.setAttribute("aria-pressed", String(q === sel.qty)); });
    var out = $("#cs-qty-out");
    if (out) { out.textContent = sel.qty; $('[data-step="-1"]').disabled = sel.qty <= C.stepper.min; $('[data-step="1"]').disabled = sel.qty >= C.stepper.max; }
    $all("[data-mode]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-mode") === sel.mode)); });
    $all("[data-rush]").forEach(function (b) { b.setAttribute("aria-pressed", String((b.getAttribute("data-rush") === "yes") === sel.rush)); });
    var rp = $("#cs-rush-price"); if (rp) rp.textContent = "+" + money2(s.rushFee);
    var rn = $("#cs-rush-note");
    if (rn) rn.textContent = sel.rush ? "Order by " + D.rushCutoff + ", and it arrives the next business day." : "Need it fast? Rush gets it to you the next business day. Order by " + D.rushCutoff + ".";
    $("#cs-design-fee").textContent = "+" + money(DESIGN_FEE);

    var ready = (sel.mode === "design" ? designReady() : allFilesIn()) && !!s.variant;
    $("#cs-confirm-text").textContent = sel.mode === "design"
      ? "I understand: you email me a proof, I get " + D.freeRevisions + " free changes, each extra change is $" + D.revisionFee + ", and it prints after I approve."
      : "My design is correct. Print it exactly like this.";
    var cb = $("#cs-confirm");
    cb.disabled = !ready;
    $("#cs-confirm-wrap").classList.toggle("cs-is-off", !ready);
    if (!ready) setConfirmed(false);
    $("#cs-add").disabled = !(ready && confirmed);
    $("#cs-add-help").textContent = !s.variant ? "This choice is not available. Please pick another."
      : !ready ? (sel.mode === "design" ? "Fill in the boxes with a *, check your spelling, then check the box." : neededFiles() > 1 ? "Upload your front and back designs, then check the box." : "Upload your design and check the box to add it to your cart.")
      : (confirmed ? "Ready! Tap Add to Cart." : "Check the box above to add it to your cart.");
  }

  /* ---------- Add to cart ---------- */
  function addProp(name, value) {
    if (value == null || value === "") return;
    var i = document.createElement("input");
    i.type = "hidden"; i.name = "properties[" + name + "]"; i.value = value;
    $("#cs-props").appendChild(i);
  }
  function showAddError(msg) {
    $("#cs-add-msg").innerHTML = '<div class="cs-status cs-err">' + ICON.err + '<div><p>' + esc(msg) + '</p></div></div>';
    $("#cs-add").disabled = false; $("#cs-add").textContent = "Add to Cart";
  }
  $("#cs-add").addEventListener("click", function () {
    var btn = $("#cs-add");
    if (btn.disabled) return;
    var s = summary();
    if (!s.variant) return;
    btn.disabled = true; btn.textContent = "Adding...";
    $("#cs-add-msg").innerHTML = "";
    $("#cs-props").innerHTML = "";
    $("#cs-variant-id").value = s.variant.id;
    $("#cs-qty-input").value = s.pieces;
    var n = neededFiles();
    // Only send the files this order needs.
    [0, 1].forEach(function (i) { var inp = fileInput(i); var use = sel.mode === "upload" && i < n && files[i]; inp.disabled = !use; if (use) inp.name = "properties[" + (n > 1 ? (i === 0 ? "Front design" : "Back design") : "Design file") + "]"; else inp.removeAttribute("name"); });
    var logoIn = miniInput("logo"), inspoIn = miniInput("inspo");
    var useLogo = sel.mode === "design" && brief.logo, useInspo = sel.mode === "design" && brief.inspo;
    logoIn.disabled = !useLogo; if (useLogo) logoIn.name = "properties[Logo]"; else logoIn.removeAttribute("name");
    inspoIn.disabled = !useInspo; if (useInspo) inspoIn.name = "properties[Inspiration picture]"; else inspoIn.removeAttribute("name");

    addProp("Design", sel.mode === "design" ? "Design it for me" : "I have my design");
    if (C.finish) addProp("Finish", finishLabel());
    if (C.sides) addProp("Print on", sidesLabel());
    addProp("_link", link);
    if (sel.mode === "upload") {
      var warned = false;
      for (var i = 0; i < n; i++) if (checkPicture(files[i], s.size).level === "warn") warned = true;
      addProp("Picture check", warned ? "Too small. May print blurry. Customer chose to go on." : "Looks good");
      addProp("Customer confirmed", "My design is correct. Print it exactly like this.");
    } else {
      addProp("Business name", $("#cs-d-biz").value.trim());
      FLDS.forEach(function (f) { addProp(f[1].replace(/ \*$/, "").replace(/ \(only if you picked front and back\)/, ""), $("#cs-d-" + f[0]).value.trim()); });
      if ($("#cs-d-nologo").checked) addProp("Logo", "No logo. Use business name.");
      addProp("Colors", $("#cs-d-colors").value.trim());
      addProp("Style", brief.style);
      addProp("Notes", $("#cs-d-notes").value.trim());
      addProp("Spelling checked", "Yes");
      addProp("Customer agreed", "Proof by email within " + D.designDays + ". " + D.freeRevisions + " free changes, then $" + D.revisionFee + " each. Prints after approval.");
    }

    function submitMain() { $("#cs-form").submit(); }
    if (sel.mode === "design") {
      if (!D.designVariant) { showAddError("Design service is not set up yet. Please email " + D.email + "."); return; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: D.designVariant, quantity: 1, properties: { "For": D.title, "_link": link } }] })
      }).then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
        .then(submitMain)
        .catch(function () { showAddError("Something went wrong. Please try again."); });
    } else {
      submitMain();
    }
  });

  /* ---------- Mode buttons, confirm, FAQ ---------- */
  $all("[data-mode]").forEach(function (b) { b.addEventListener("click", function () {
    sel.mode = b.getAttribute("data-mode"); setConfirmed(false);
    renderUploads(); renderDesignForm(); renderDelivery(); refresh();
  }); });
  $("#cs-confirm").addEventListener("change", function (e) { confirmed = e.target.checked; refresh(); });

  var faq = [
    ["What files can I upload?", "JPG, PNG, or PDF. For the sharpest print, send a big, clear picture made at the size you ordered."],
    ["When will it arrive?", "About " + D.deliveryDays + " when you upload a ready design. Need it faster? Pick Rush and order by " + D.rushCutoff + " to get it the next business day. If we design it for you, the clock starts after you approve your proof."],
    ["Can you make the design for me?", "Yes. Pick \"Design it for me\" for " + money(DESIGN_FEE) + ". Answer a few questions, upload your logo, and we email you a proof within " + D.designDays + ". You get " + D.freeRevisions + " free changes. Each change after that is $" + D.revisionFee + ". We print after you approve it."],
    ["What if my file is wrong?", "We print your design exactly as you send it, so please check the preview before you order. If you see a mistake after ordering, email " + D.email + " right away and we will help."]
  ];
  $("#cs-faq").innerHTML = '<h3>Questions</h3>' + faq.map(function (q) { return '<details><summary>' + esc(q[0]) + '</summary><p>' + esc(q[1]) + '</p></details>'; }).join("");

  // Back button can restore a page with stale file inputs; start clean.
  window.addEventListener("pageshow", function (e) { if (e.persisted) { $("#cs-add").textContent = "Add to Cart"; refresh(); } });

  buildOptions();
  renderUploads();
  renderDesignForm();
  renderDelivery();
  refresh();
})();
